export default {
  props: [
    {
      attr: 'phone',
      name: '手机号'
    },
    {
      attr: 'userId',
      name: '是否注册',
      slot: 'userId'
    },
    {
      attr: 'realname',
      name: '用户名字',
      slot: 'realname'
    },
    {
      attr: 'age',
      name: '用户年龄'
    }
  ]
}
